'use client';

import { c as _c } from "react/compiler-runtime";
import { Minus, Moon, Plus } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { Button } from '~/components/Button';
import type { ItineraryCardNightStepperProps } from './ItineraryCard.types';
import styles from './ItineraryCardNightStepper.module.css';
export function ItineraryCardNightStepper(t0) {
  const $ = _c(33);
  const {
    nights,
    onDecrement,
    onIncrement,
    readOnly: t1
  } = t0;
  const readOnly = t1 === undefined ? false : t1;
  const t = useTranslations("journey");
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className={styles.labelIcon} aria-hidden="true"><Moon size="small" decorative={true} /></span>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== nights || $[2] !== t) {
    t3 = t("itinerary_night_label", {
      count: nights
    });
    $[1] = nights;
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className={styles.label}>{t2}<span className={styles.labelText}>{t3}</span></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("itinerary_decrease_nights");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = readOnly || nights <= 1;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Minus size="small" decorative={true} />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== onDecrement || $[10] !== t5 || $[11] !== t6) {
    t8 = <span className={styles.stepperButton}><Button variant="neutral" size="extraSmall" aria-label={t5} isDisabled={t6} onPress={onDecrement} dataTestId="night-stepper-decrement">{t7}</Button></span>;
    $[9] = onDecrement;
    $[10] = t5;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== nights || $[14] !== t) {
    t9 = t("nights_count", {
      count: nights
    });
    $[13] = nights;
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== nights || $[17] !== t9) {
    t10 = <output className={styles.count} aria-live="polite" aria-label={t9}>{nights}</output>;
    $[16] = nights;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("itinerary_increase_nights");
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Plus size="small" decorative={true} />;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== onIncrement || $[23] !== readOnly || $[24] !== t11) {
    t13 = <span className={styles.stepperButton}><Button variant="neutral" size="extraSmall" aria-label={t11} isDisabled={readOnly} onPress={onIncrement} dataTestId="night-stepper-increment">{t12}</Button></span>;
    $[22] = onIncrement;
    $[23] = readOnly;
    $[24] = t11;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t10 || $[27] !== t13 || $[28] !== t8) {
    t14 = <div className={styles.controls}>{t8}{t10}{t13}</div>;
    $[26] = t10;
    $[27] = t13;
    $[28] = t8;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14 || $[31] !== t4) {
    t15 = <div className={styles.stepper}>{t4}{t14}</div>;
    $[30] = t14;
    $[31] = t4;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
}